<template>
  <div class="lg:!mx-0 flex">
    <Transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__faster"
    >
      <div class="flex max-h-content w-screen min-h-content p-4">
        <SelfPerformDashboardLayout />
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import SelfPerformDashboardLayout from '@/components/SelfPerform/Dashboard/SelfPerformDashboardLayout.vue';
import { useProjectTypeRedirect } from '@/composables/useProjectTypeRedirect';

useProjectTypeRedirect();
</script>

<style scoped></style>
